module.exports = __webpack_public_path__ + "img/calendar.772457de.svg";